import Component from '@glimmer/component';

export default class NotAvailableLabelComponent extends Component {
  get hideLabel() {
    const { hideAddToChart, product_status_id } = this.args;

    if (hideAddToChart && product_status_id && hideAddToChart[product_status_id]) {
      return {
        text: 'not_available_online',
        class: 'not-online',
      };
    }

    return {
      text: 'not_available',
      class: '',
    };
  }
}
